<!-- 上方标题栏 -->
<template>
  <a-flex class="content" justify="space-between" align="center">
    <CompanyIcon class="left" pattern="color" size="normal"></CompanyIcon>
    <a-flex align="center" class="right">
      <div
        v-for="item in title"
        :key="item.id"
        class="card"
        :class="newId == item.id ? 'card-new' : ''"
        @click="gotoPage(item.name)"
      >
        {{ item.title }}
      </div>
    </a-flex>
  </a-flex>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import CompanyIcon from "./CompanyIcon.vue";
import { title } from "@/common/param";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    newId: Number,
  },
  components: {
    CompanyIcon,
  },
  name: "TopBar",
  setup(props, ctx) {
    const router = useRouter();
    function gotoPage(name: any) {
      router.push("/" + name);
    }
    return { title, gotoPage };
  },
});
</script>

<style scoped lang="scss">
.content {
  width: 1920px;
  min-width: 1024px;
  padding: 16px 0;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 100;
  .left {
    margin-left: 260px;
  }
  .right {
    margin-right: 260px;
    .card {
      padding: 10px 16px;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      cursor: pointer;
      margin-left: 73px;
      border-bottom: 2px solid transparent;
      &-new {
        border-bottom: 2px solid #356fd0;
        color: #356fd0;
      }
    }
  }
}
</style>
